import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PreviewDialog = ({ open, onClose, file, label }) => {
  const renderPreview = () => {
    if (!file) return null;

    // Handle restored documents (URL-based)
    if (file.isUrl) {
      return (
        <iframe
          src={file.url}
          title={label}
          width="100%"
          height="100%"
          style={{ border: 0 }}
        />
      );
    }

    // Handle regular file objects
    return (
      <iframe
        src={URL.createObjectURL(file)}
        title={label}
        width="100%"
        height="100%"
        style={{ border: 0 }}
      />
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle sx={{ m: 0, p: 1, fontSize: '1.25rem' }}>
        {label} {file?.isUrl && '(Restored Document)'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, height: '100%' }}>
        {renderPreview()}
      </DialogContent>
    </Dialog>
  );
};

export default PreviewDialog;